import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  /** 제목 옆에 인라인으로 붙는 추가 노드 (예: 복사 아이콘 버튼). */
  titleSuffix?: ReactNode;
  count?: number;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, titleSuffix, count, description, actions }: PageHeaderProps) {
  return (
    <header className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="flex items-center gap-1.5 text-2xl font-semibold tracking-tight">
          <span>{title}</span>
          {typeof count === 'number' ? (
            <span className="text-base font-normal text-foreground-muted">{count}</span>
          ) : null}
          {titleSuffix}
        </h1>
        {description ? <p className="mt-1.5 text-sm text-foreground-muted">{description}</p> : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </header>
  );
}
